<template lang="pug">
  .height-100
    //- h3.title Reportes de boletas
    //- p

    transition-group.contenedor-box(name="fade-smooth-two", tag="div")
      .box.position-relative(v-if="mostrarReporteBoletas", key="reporte_boletas")
        lista-boletas(
          @close="mostrarReporteBoletas = false"
        )

</template>

<script>
import ListaBoletasComponent from './Component_Boletas_Reporte_Lista'
export default {
  name: 'boletas-reportes',
  components: {
    'lista-boletas': ListaBoletasComponent
  },
  props: ['tipo'],
  data () {
    return {
      mostrarReporteBoletas: true
    }
  },
  watch : {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-box
    display flex
    justify-content center
    flex-direction column
    position relative
    >*
      transition all .5s
      width 100%
</style>



// WEBPACK FOOTER //
// View_Boletas_Reporte.vue?519b6c47